import Service from "./config/ConfigRepository";

export default {
  async login(credentials) {
    return await Service.post(`login`, credentials);
  },
};
